module.exports = __webpack_public_path__ + "static/media/play-run.012d1b9d.png";